"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickAwayListener = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ClickAwayListener = function (_a) {
    var onClickAway = _a.onClickAway, children = _a.children;
    var containerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        var handleClickOutside = function (event) {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                onClickAway();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function () {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [onClickAway]);
    return (0, jsx_runtime_1.jsx)("div", __assign({ ref: containerRef }, { children: children }));
};
exports.ClickAwayListener = ClickAwayListener;
